<template>
  <div v-if="isAuth(permission_code,'WxAccount')">
    <el-select v-model="selectedAppid" size="small" v-loading="dataListLoading"  @change="selectAccount" filterable>
      <el-option v-for="item in accountList" :key="item.appid" :label="item.name+'（'+ACCOUNT_TYPES[item.type]+'）'" :value="item.appid"></el-option>
    </el-select>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import {getWxAccountList,switchAccount} from "src/api/weAccount";
import {Message} from "element-ui";
import { isAuth } from 'src/utils'

export default {
  data() {
    return {
      dataListLoading: false
    }
  },
  computed: mapState({
    accountList: state=>state.wxAccount.accountList,
    ACCOUNT_TYPES: state=>state.wxAccount.ACCOUNT_TYPES,
    selectedAppid:state=>state.wxAccount.selectedAppid,
    permission_code: state => state.user.permission_code
  }),
  mounted(){
    if(isAuth(this.permission_code,'WxAccount'))
    {
      this.getDataList()
    }

  },
  methods:{
    async getDataList() {
      this.dataListLoading = true
      const response = await getWxAccountList(this.dataForm)
      if(response)
      {
        if(Object.prototype.hasOwnProperty.call(response,'success'))
        {
          if(response['success'])
          {
            this.$store.commit('wxAccount/updateAccountList', response.data)
            if(!response.data.length){
              this.$message.info("公众号列表为空，请先添加")
            }
          }
          else
          {
            Message({
              message: response['errorMsg'],
              type: 'error',
              duration: 5 * 1000
            })
          }
        }
        else
        {
          Message({
            message: "request failed",
            type: 'error',
            duration: 5 * 1000
          })
        }
      }
      this.dataListLoading = false
    },
    async switchToAccount(appid) {
      await switchAccount(appid)
    },
    selectAccount(appid){
      if(this.selectedAppid !==appid){
        this.$store.commit('wxAccount/selectAccount', appid)
        this.switchToAccount(appid)
      }
    }
  }
}
</script>
